import CheckIcon from '@mui/icons-material/Check';
import BlockIcon from '@mui/icons-material/Block';
import { Box, Button, Tooltip } from '@mui/material';
import { colors } from '@src/styles';
import { toneButtonSX } from '../scriptsStyles';
import { RunButton } from './RunButton';
import { useScriptsContext } from '../context/ScriptsContext';

interface GroupActionButtonsProps {
  onBlock: () => void;
  onApprove: () => void;
  onRun: () => void;
  isBlocking: boolean;
  isApproving: boolean;
  isRunningScript: boolean;
}

export const GroupActionButtons = ({
  onBlock,
  onApprove,
  onRun,
  isBlocking,
  isApproving,
  isRunningScript,
}: GroupActionButtonsProps) => {
  const { scriptStatus, selectedScript } = useScriptsContext();
  const isBlocked = scriptStatus === 'BLOCKED';
  const isFinished = scriptStatus === 'FINISHED';
  const isFailed = scriptStatus === 'FAILED';
  const readyToRunScript = Boolean(selectedScript?.approvedByUserId || selectedScript?.setup?.id);

  const blockDisabled = isBlocked || isFinished || isFailed || isBlocking;
  const blockTooltip = isBlocked
    ? 'Este script já está bloqueado'
    : isFinished
      ? 'Não é possível bloquear um script já finalizado'
      : isFailed
        ? 'Não é possível bloquear um script que falhou'
        : '';

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {/* Block */}
      <Tooltip title={blockTooltip} arrow>
        <span>
          <Button
            onClick={onBlock}
            disabled={blockDisabled}
            startIcon={<BlockIcon />}
            sx={toneButtonSX(colors.status.rejected)}
          >
            {isBlocking ? 'Bloqueando...' : isBlocked ? 'Bloqueado' : isFinished || isFailed ? '...' : 'Bloquear'}
          </Button>
        </span>
      </Tooltip>
      <SwitchButton
        onRun={onRun}
        onApprove={onApprove}
        readyToRun={readyToRunScript}
        isApproving={isApproving}
        isRunningScript={isRunningScript}
      />
    </Box>
  );
};

interface SwitchButtonProps {
  onRun: () => void;
  onApprove: () => void;
  readyToRun?: boolean;
  isApproving: boolean;
  isRunningScript: boolean;
}

const SwitchButton = ({ onRun, onApprove, readyToRun, isApproving, isRunningScript }: SwitchButtonProps) => {
  // No approval needed in development
  if (readyToRun || process.env.NODE_ENV === 'dev') {
    return <RunButton onClick={onRun} isRunningScript={isRunningScript} />;
  }

  return (
    <Button
      onClick={onApprove}
      disabled={isApproving}
      startIcon={<CheckIcon />}
      sx={toneButtonSX(colors.status.concluded)}
    >
      {isApproving ? 'Aprovando...' : 'Aprovar'}
    </Button>
  );
};
